<template>
  <div class="week-box">
    <div class="week-title">
      <div v-for="(week, index) in weekTitle" :key="`weekTitle${index}`" class="week">{{ week }}</div>
    </div>
    <div class="week-day">
      <div
        v-for="(day, index) in weekDay"
        :key="`weekDay${index}`"
        class="day"
        @click="tabChange(day)"
      >
        <div :class="{'disabled': showDisabled(day.name), 'active': day.name === value}" class="day-con">{{ day.hint }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Week',
  model: {
    event: 'tabChange'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    weekStatus: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: true,
      weekTitle: [],
      weekDay: []
    }
  },
  mounted() {
    this.weekTitleFun()
    this.weekDayFun()
  },
  methods: {
    showDisabled(name) {
      if (Object.keys(this.weekStatus).length === 0) {
        return false
      }

      if (this.weekStatus && !this.weekStatus[name]) {
        return true
      }

      return false
    },

    weekTitleFun() {
      const week = ['日', '一', '二', '三', '四', '五', '六']
      const weekTitle = []
      for (let i = 0; i < 7; i++) {
        const nowDate = new Date().getTime() + (i * 1000 * 60 * 60 * 24)
        weekTitle.push(week[new Date(nowDate).getDay()])
      }

      this.weekTitle = weekTitle
    },

    weekDayFun() {
      const weekDay = []
      for (let i = 0; i < 15; i++) {
        const nowDate = new Date().getTime() + (i * 1000 * 60 * 60 * 24)
        weekDay.push({
          name: this.$utils.dateFormat('YYYY-mm-dd', new Date(nowDate)),
          hint: new Date(nowDate).getDate(),
          active: false
        })
      }

      this.weekDay = weekDay
    },

    tabChange(day) {
      if (this.showDisabled(day.name)) {
        return
      }

      this.date = day.name
      this.$emit('tabChange', day.name)
    }
  }
}
</script>

<style scoped lang="less">
  .week-box {
    padding-bottom: 10px;
    background-color: #ffffff;
    .week-title {
      overflow: auto;
      padding: 10px 0;
      position: relative;
      .week {
        width: 14.28%;
        float: left;
        text-align: center;
      }

      &::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0.16rem;
        bottom: 0;
        left: 0.16rem;
        border-bottom: 0.01rem solid #ebedf0;
        -webkit-transform: scaleY(.5);
        transform: scaleY(.5);
      }
    }

    .week-day {
      overflow: auto;
      .day {
        width: 14.28%;
        float: left;
        text-align: center;
        margin-top: 10px;

        .day-con {
          width: 30px;
          height: 30px;
          margin: 0 auto;
          line-height: 30px;
        }

        .active {
          background-color: #ee0a24;
          color: #ffffff;
          border-radius: 50%;
        }
      }

      .disabled {
        color: #adadad
      }
    }
  }
</style>
